// extracted by mini-css-extract-plugin
module.exports = {"globalSocialLinkWrapper":"global-social-link-icons_globalSocialLinkWrapper__3G5lw"};